'use strict';
import sxQuery from '../../sxQuery/sxQuery';
import SxQueryUtils from '../../sxQuery/SxQueryUtils';
var ACTIVE_CLASS = 'ss360-color-tile--selected';
var toggleSelection = function (tile, label, isSelected, pluginConfiguration) {
    if (isSelected === void 0) { isSelected = true; }
    if (isSelected) {
        tile.addClass(ACTIVE_CLASS);
        label.css('box-shadow', "inset 0 0 0 4px ".concat(pluginConfiguration.style.accentColor));
    }
    else {
        tile.removeClass(ACTIVE_CLASS);
        label.css('box-shadow', null);
    }
};
var ColorTileFilter = /** @class */ (function () {
    function ColorTileFilter(wrapper, options, activeOptions, counts, showCounts, pluginConfig, changeCallback) {
        this.nodeMap = {};
        this.shouldApplyPolyfill = ('msGridColumn' in document.documentElement.style);
        this.showColorLabels = true;
        this.wrapper = wrapper;
        this.options = options;
        this.activeOptions = activeOptions;
        this.counts = counts;
        this.showCounts = showCounts;
        this.pluginConfig = pluginConfig;
        this.changeCallback = changeCallback;
        this.showColorLabels = this.pluginConfig.filters.showColorLabels;
        this.render();
    }
    ColorTileFilter.prototype.applyPolyfill = function (nodes) {
        if (!this.shouldApplyPolyfill) {
            return;
        }
        var row = 0;
        nodes.forEach(function (tile, idx) {
            var mod = idx % 4;
            if (mod === 0) {
                row++;
            }
            tile.css('ms-grid-column', mod + 1);
            tile.css('ms-grid-row', row);
        });
    };
    ColorTileFilter.prototype.createNode = function (option) {
        var _this = this;
        var id = "ss360-color-".concat(Math.round(10000 * Math.random()));
        var color = option.color || '#ffffff';
        var count = this.counts[option.key] !== undefined ? this.counts[option.key] : option.count;
        var countText = this.showCounts && count !== undefined ? " (".concat(count, ")") : '';
        var tooltipLabel = "".concat(option.name).concat(countText);
        var isSelected = (this.activeOptions || []).indexOf(option.key) !== -1;
        var tile = this.showColorLabels ? sxQuery('<div class="ss360-color-tile ss360-color-tile--show-labels"></div>') : sxQuery('<div class="ss360-color-tile"></div>');
        var val = (option.value !== undefined ? option.value : option.key);
        this.nodeMap[option.key] = tile;
        var checkbox = sxQuery("<input type=\"checkbox\" id=\"".concat(id, "\" value=\"").concat(val, "\" class=\"ss360-color-tile__checkbox\"").concat(isSelected ? ' checked' : '', ">"));
        var label = sxQuery("<label for=\"".concat(id, "\" class=\"ss360-color-tile__label\"></label>"));
        var backgroundStyle = color && color.indexOf('linear-gradient') !== -1 ? 'background' : 'background-color';
        var inner = sxQuery("<span role=\"presentation\" class=\"ss360-color-tile__color\" style=\"".concat(backgroundStyle, ": ").concat(color, "\"></span>"));
        checkbox.on('focus', function () {
            // Show tooltip or label
            var tooltip = tile.find('.ss360-color-tile__tooltip');
            tooltip.css('display', 'block');
        }).on('blur', function () {
            // Hide tooltip or label unless it's checked (selected)
            if (!checkbox.get(0).checked) {
                var tooltip = tile.find('.ss360-color-tile__tooltip');
                tooltip.css('display', 'none');
            }
        });
        if (isSelected) {
            toggleSelection(tile, label, true, this.pluginConfig);
        }
        var colors = color.split(',');
        if (colors.length > 1 && color.match(/rgba?/) === null) {
            var gradientParts_1 = [];
            var currentPercent_1 = 0;
            var percentIncrement_1 = 100 / colors.length;
            colors.forEach(function (c) {
                gradientParts_1.push("".concat(c, " ").concat(currentPercent_1.toFixed(2), "%"));
                currentPercent_1 += percentIncrement_1;
                gradientParts_1.push("".concat(c, " ").concat(currentPercent_1.toFixed(2), "%"));
            });
            inner.css('background-color', null);
            inner.css('background-image', "linear-gradient(90deg, ".concat(gradientParts_1.join(','), ")"));
        }
        label.append(inner);
        if (this.showColorLabels) {
            var colorTextLabel = sxQuery("<span class=\"ss360-color-tile__color-name\">".concat(option.name, "</span>"));
            label.append(colorTextLabel);
            label.attr('title', tooltipLabel);
        }
        else {
            var tooltip_1 = sxQuery("<span class=\"ss360-color-tile__tooltip\">".concat(tooltipLabel, "</span>"));
            label.append(tooltip_1);
            var isUpdating_1 = false;
            var isMouseOver_1 = false;
            tile.on('mousemove', function (e) {
                isMouseOver_1 = true;
                if (isUpdating_1)
                    return;
                isUpdating_1 = true;
                SxQueryUtils.requestAnimationFrame(function () {
                    try {
                        var rect = tile.get()[0].getBoundingClientRect();
                        var topDiff = e.clientY - rect.top;
                        var leftDiff = e.clientX - rect.left;
                        tooltip_1.css('left', "".concat(Math.round(leftDiff) + 5, "px"));
                        tooltip_1.css('top', "".concat(Math.round(topDiff) + 3, "px"));
                        tooltip_1.css('display', 'block');
                    }
                    catch (ex) {
                        // ccl, will still look fine
                    }
                    isUpdating_1 = false;
                });
            }).on('mouseout', function () {
                isMouseOver_1 = false;
                setTimeout(function () {
                    if (!isMouseOver_1) {
                        tooltip_1.css('left', null);
                        tooltip_1.css('top', null);
                        tooltip_1.css('display', 'none');
                    }
                }, 100);
            }).on('click', function () {
                // New click handler to ensure tooltip is hidden after a click
                if (!_this.showColorLabels) {
                    var tooltip_2 = tile.find('.ss360-color-tile__tooltip');
                    tooltip_2.css('left', null);
                    tooltip_2.css('top', null);
                    tooltip_2.css('display', 'none');
                }
            });
        }
        tile.append(checkbox);
        tile.append(label);
        return tile;
    };
    ColorTileFilter.prototype.render = function () {
        var _this = this;
        var options = this.options;
        var sortedNodes = options.map(function (option) {
            var tile = _this.createNode(option);
            _this.wrapper.append(tile);
            return tile;
        });
        this.applyPolyfill(sortedNodes);
        this.bindChangeHandler();
    };
    ColorTileFilter.prototype.bindChangeHandler = function () {
        var _this = this;
        this.wrapper.find('.ss360-color-tile__checkbox').off('change.colorTile').on('change.colorTile', function (e) {
            var tile = sxQuery(e.target).parents('.ss360-color-tile', true);
            var label = tile.find('.ss360-color-tile__label');
            toggleSelection(tile, label, e.target.checked, _this.pluginConfig);
            _this.changeCallback(e.target.value, e.target.checked);
        });
    };
    ColorTileFilter.prototype.update = function (filterGroup, active) {
        var _this = this;
        var updatedKeys = [];
        var sortedNodes = [];
        this.activeOptions = active || [];
        this.counts = filterGroup.counts || this.counts;
        // Explicitly unselect all tiles before processing updates
        Object.values(this.nodeMap).forEach(function (tile) {
            toggleSelection(tile, tile.find('.ss360-color-tile__label'), false, _this.pluginConfig);
            tile.find('.ss360-color-tile__checkbox').attr('checked', null).get(0).checked = false;
        });
        filterGroup.values.forEach(function (option) {
            var node = _this.nodeMap[option.key];
            if (node === undefined) {
                node = _this.createNode(option);
                _this.wrapper.append(node);
            }
            else {
                node.show();
            }
            var isSelected = _this.activeOptions.indexOf(option.key) !== -1;
            if (isSelected) {
                toggleSelection(node, node.find('.ss360-color-tile__label'), true, _this.pluginConfig);
                var checkbox = node.find('.ss360-color-tile__checkbox');
                checkbox.attr('checked', 'checked');
                checkbox.get(0).checked = true;
            }
            var count = _this.counts[option.key] !== undefined ? _this.counts[option.key] : option.count;
            var countText = _this.showCounts && count !== undefined ? " (".concat(count, ")") : '';
            var tooltipLabel = "".concat(option.name).concat(countText);
            if (_this.showColorLabels) {
                node.find('.ss360-color-tile__label').attr('title', tooltipLabel);
            }
            else {
                node.find('.ss360-color-tile__tooltip').text(tooltipLabel);
            }
            sortedNodes.push(node);
            updatedKeys.push(option.key);
        });
        this.bindChangeHandler();
        this.applyPolyfill(sortedNodes);
        Object.keys(this.nodeMap).forEach(function (key) {
            if (updatedKeys.indexOf(key) === -1) {
                _this.nodeMap[key].hide();
            }
        });
        sortedNodes.forEach(function (node, idx) {
            _this.wrapper.ensureChildPosition(node.get(0), idx);
        });
        return updatedKeys.length > 0;
    };
    return ColorTileFilter;
}());
export default ColorTileFilter;
